<template>
  <div class="c-searchServiceCarousel">
    <ContentHeadline
      class="c-searchServiceCarousel_headline"
      :class="{ 'c-searchServiceCarousel_headline-hasSubTitle': !!subTitle }"
      title-tag="h2"
      :titleText="title"
      :sub-title-text="subTitle"
      :rightLink="getShowMore()"
    />
    <CassetteCarousel
      class="c-searchServiceCarousel_list"
      :slides-count="slidesCount"
      :pc-sizes="['FULL']"
    >
      <ServiceCassette
        class="c-searchServiceCarousel_item"
        v-for="(service, index) in services"
        :service="service"
        :key="`services-${service.id}`"
        :item-number="index + 1"
        :is-ranking="isRanking"
        :display-rating="displayRating"
      />

    </CassetteCarousel>
  </div>
</template>

<script>
import ContentHeadline from '~/components/molecules/ContentHeadline'
import CassetteCarousel from '~/components/molecules/CassetteCarousel'
import ServiceCassette from '~/components/molecules/ServiceCassette'
import LinkRefProvider from '~/mixins/link-ref/LinkRefProvider'

const SERVICES_PER_SLIDE = 6

/** @type {import('vue').ComponentOptions} */
const searchServiceCarousel = {
  name: 'SearchServiceCarousel',
  mixins: [LinkRefProvider],
  components: {
    ContentHeadline,
    ServiceCassette,
    CassetteCarousel
  },
  props: {
    services: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      default: null
    },
    showMoreUrl: {
      type: String,
      default: null
    },
    isRanking: {
      type: Boolean,
      default: false
    },
    /** 評価表示フラグ */
    displayRating: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    slidesCount() {
      return Math.ceil(this.services.length / SERVICES_PER_SLIDE)
    }
  },
  methods: {
    getShowMore() {
      if (this.showMoreUrl) {
        const refQuery = (/\?.+/.test(this.showMoreUrl) ? '&' : '?') + `ref=${this.linkRef}`
        return {
          text: `${this.title}をもっと見る`,
          link: this.showMoreUrl + refQuery
        }
      }
      return null
    }
  }
}
export default searchServiceCarousel
</script>

<style lang="scss" scoped>
.c-searchServiceCarousel {
  &_list {
    margin-top: 16px;
    /deep/ {
      .c-cassetteCarousel_inner {
        margin-left: 0;
      }
    }
  }
  &_item {
    width: 152px;
    flex-shrink: 0;
    margin-right: 8px;
    &:nth-child(6n) {
      margin-right: 12px;
    }
  }
}
@media (max-width: breakpoint(Search, XL) - 1) {
  .c-searchServiceCarousel {
    &_item {
      &:nth-child(6n) {
        margin-right: 8px;
      }
    }
  }
}
@media (max-width: breakpoint(Search, M)) {
  .c-searchServiceCarousel {
    &_headline {
      padding: 0 12px;
      &-hasSubTitle {
        flex-wrap: wrap;
        justify-content: flex-end !important;
        /deep/ .c-contentHeadline {
          &_title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-basis: 100%;
          }
        }
      }
      // SP表示では右から5文字("もっと見る")のみ表示する
      /deep/ .c-contentHeadline {
        &_rightLink {
          display: flex;
          justify-content: flex-end;
          overflow: hidden;
          width: 5em;
          white-space: nowrap;
        }
      }
    }
    &_list {
      margin-top: 8px;
      /deep/ {
        .c-cassetteCarousel_inner {
          margin-left: 12px;
        }
      }
    }
    &_item {
      width: 138px;
    }
  }
}
</style>
